

// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import './oversummary.css';

// function OversSummary() {
//   const [oversData, setOversData] = useState({});
//   const match_id = localStorage.getItem('match_id');
//   const navigate = useNavigate();

//   useEffect(() => {
//     fetch(`https://nammateam.onrender.com/oversall/summary/allovers/${match_id}`)
//       .then(res => res.json())
//       .then(data => {
//         if (data.success) setOversData(data.overs);
//       })
//       .catch(err => {
//         console.error("Failed to fetch overs data", err);
//         setOversData({});
//       });
//   }, [match_id]);

//   const getBallClass = (val) => {
//     if (val.startsWith("Wd") || val.startsWith("Nb") || val.startsWith("B") || val.startsWith("Lb")) return "os-ball os-extra";
//     if (val === "W") return "os-ball os-red";
//     if (val === "4") return "os-ball os-orange";
//     if (val === "6") return "os-ball os-green";
//     return "os-ball";
//   };

//   // if (!oversData || Object.keys(oversData).length === 0) {
//   //   return <p className="os-loading">Loading overs summary...</p>;
//   // }

//   return (
//     <div className="os-overs-container">
      
//       {/* ✅ Header with Back Button */}
//       <div className="os-header">
//         <button className="os-back-btn" onClick={() => navigate("/live")}>
//           ← Back
//         </button>
//         <h2>Overs Summary</h2>
//       </div>

//       {Object.keys(oversData)
//         .sort((a, b) => b - a)  // latest first
//         .map(overNo => {
//           const over = oversData[overNo] || {};
//           const overBalls = over.balls || [];
//           const bowler = over.bowler || "";
//           const overRuns = over.runs || 0;

//           return (
        
//             <div key={overNo} className="os-over-block">
//   {/* ✅ Over Heading */}
//   <div className="os-over-header">
//     <span className="os-over-info"> <span className="os-over-name" >  Over {parseInt(overNo) + 1}</span>  </span>
//     <span>{bowler}</span>
//     <span className="os-over-runs">{overRuns} Runs</span>
//   </div>
// <hr></hr>
//   {/* Balls row */}
//   <div className="os-balls">
//     {overBalls.map((ball, idx) => (
//       <div className={getBallClass(ball)} key={idx}>
//         {ball}
//       </div>
//     ))}
//   </div>
// </div>

//           );
//         })}
//     </div>
//   );
// }

// export default OversSummary;

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import './oversummary.css';

function OversSummary() {
  const [oversData, setOversData] = useState({});
  const match_id = localStorage.getItem('match_id');
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`https://nammateam.onrender.com/oversall/summary/allovers/${match_id}`)
      .then(res => res.json())
      .then(data => {
        if (data.success) setOversData(data.overs);
        else setOversData({});
      })
      .catch(err => {
        console.error("Failed to fetch overs data", err);
        setOversData({});
      });
  }, [match_id]);

  const getBallClass = (val) => {
    if (val.startsWith("Wd") || val.startsWith("Nb") || val.startsWith("B") || val.startsWith("Lb")) return "os-ball os-extra";
    if (val === "W") return "os-ball os-red";
    if (val === "4") return "os-ball os-orange";
    if (val === "6") return "os-ball os-green";
    return "os-ball";
  };

  if (!oversData || Object.keys(oversData).length === 0) {
    return <p className="os-loading">No overs data available</p>;
  }

  return (
    <div className="os-overs-container">
      {/* Header */}
      <div className="os-header">
        <button className="os-back-btn" onClick={() => navigate("/live")}>
          ← Back
        </button>
        <h2>Overs Summary</h2>
      </div>

      {Object.keys(oversData)
        .sort((a, b) => b - a)  // latest first
        .map(overNo => {
          const over = oversData[overNo] || {};
          const overBalls = over.balls || [];
          const bowler = over.bowler || "";
          const overRuns = over.runs || 0;

          return (
            <div key={overNo} className="os-over-block">
              {/* Over Heading */}
              <div className="os-over-header">
                <span className="os-over-info">
                  <span className="os-over-name">Over {parseInt(overNo) + 1}</span>
                </span>
                <span>{bowler}</span>
                <span className="os-over-runs">{overRuns} Runs</span>
              </div>
              <hr />
              {/* Balls row */}
              <div className="os-balls">
                {overBalls.map((ball, idx) => (
                  <div className={getBallClass(ball)} key={idx}>
                    {ball}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
    </div>
  );
}

export default OversSummary;
